import { render, staticRenderFns } from "./GradingPaper.vue?vue&type=template&id=5195e7cb&scoped=true&"
import script from "./GradingPaper.vue?vue&type=script&lang=js&"
export * from "./GradingPaper.vue?vue&type=script&lang=js&"
import style0 from "./GradingPaper.vue?vue&type=style&index=0&id=5195e7cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5195e7cb",
  null
  
)

export default component.exports